import { JsonServiceClient } from "@servicestack/client"

export const DefaultClient = (baseUrl?: string, basePath?: string) => {
    const client = new JsonServiceClient(baseUrl)
    .apply(c => {
        c.basePath = basePath ?? null;
        c.headers = new Headers() //avoid pre-flight CORS requests
    });

    client.exceptionFilter = (res: Response, error: any) => {
        if (res.status === 401) {
            global.location.href = `/auth/openiddict?redirect=${encodeURIComponent(global.location.pathname + global.location.search)}`;
        }
    };

    return client;
}

export default DefaultClient;